/* fx-notice.js — indicative EUR->home-currency conversion for the "Paying in EUR" notice.
   Fills every .fx-notice[data-fx-cents][data-fx-ccy] with "approx. N CCY".
   Live rates from open.er-api.com (no key, CORS-ok), cached in sessionStorage,
   with a static fallback so a failed fetch still shows a number.
   Re-runs on variant changes and product-rerender DOM swaps; also exposes window.__fxFill(). */
(function () {
  var FALLBACK = { USD: 1.14, GBP: 0.85, AUD: 1.65, CAD: 1.62, HKD: 8.96, SGD: 1.48, CHF: 0.92, NOK: 11.1 };
  var RATES = null;

  function fillAll() {
    var nodes = document.querySelectorAll('.fx-notice[data-fx-cents]');
    if (!nodes.length) return;
    nodes.forEach(function (el) {
      var cents = parseFloat(el.getAttribute('data-fx-cents') || '0');
      var ccy = el.getAttribute('data-fx-ccy') || 'USD';
      var rate = (RATES && RATES[ccy]) || FALLBACK[ccy];
      if (!rate || !cents) return;
      var val = (cents / 100) * rate;
      val = Math.ceil(val / 5) * 5; // round UP to nearest 5 (customer gets a happy surprise)
      var money;
      try {
        money = new Intl.NumberFormat('en-US', { style: 'currency', currency: ccy, maximumFractionDigits: 0 }).format(val);
      } catch (e) {
        money = val.toLocaleString('en-US') + ' ' + ccy;
      }
      if (el.getAttribute('data-fx-format') === 'plain') {
        el.textContent = money;
      } else {
        el.textContent = 'approx. ' + money;
      }
    });
  }
  window.__fxFill = fillAll;

  function load() {
    try {
      var cached = sessionStorage.getItem('fxEUR_v1');
      if (cached) { RATES = JSON.parse(cached); }
    } catch (e) {}
    fillAll();
    fetch('https://open.er-api.com/v6/latest/EUR')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.result === 'success' && d.rates) {
          RATES = d.rates;
          try { sessionStorage.setItem('fxEUR_v1', JSON.stringify(d.rates)); } catch (e) {}
          fillAll();
        }
      })
      .catch(function () {});
  }

  if (document.readyState !== 'loading') load();
  else document.addEventListener('DOMContentLoaded', load);

  // Re-fill after Prestige variant changes (data-fx-cents is re-rendered server-side on the PDP).
  ['variant:change', 'on:variant:change', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, fillAll);
  });

  // product-rerender swaps DOM without firing our events reliably — observe + debounce.
  var deb;
  if (document.body) {
    new MutationObserver(function () {
      clearTimeout(deb);
      deb = setTimeout(fillAll, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
